export default __webpack_public_path__ + "static/media/General's Armguards of Heaven's Pass.4d662061.jpg";